module.exports = __webpack_public_path__ + "img/KN.e99019b0.svg";